export default {
  setCurrentSessionStatus(state, payload) {
    state.current_session_status = payload
  },
  setCurrentLanguage(state, language) {
    state.language = language
  },
  add_ajax_spin(state) {
    state.ajax_spin_count++
  },
  sub_ajax_spin(state) {
    state.ajax_spin_count--
  },
  reset_ajax_spin(state) {
    state.ajax_spin_count = 0
  },
  set_stage_status_list(state, payload) {
    state.stage_status_list = payload
  },
  setUserInfo(state, payload) {
    state.user_info = payload
  },
  set_place_map(state,payload) {
    state.place_map = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js